import { render } from "./AddressInvoice.vue?vue&type=template&id=71ee7325"
import script from "./AddressInvoice.vue?vue&type=script&lang=js"
export * from "./AddressInvoice.vue?vue&type=script&lang=js"

import "./AddressInvoice.vue?vue&type=style&index=0&id=71ee7325&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__